import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ScaffoldLogo from "../../assets/images/logo/SCAFFOLD.svg";
import EyeSlash from "../../assets/images/eye-slash.svg";
import Eye from "../../assets/images/eye.svg";

function Login() {
    let navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);


    const auth = () => {
        if (username === 'stewart.k@deliverain.com' && password === 'welcome') {
            sessionStorage.setItem("role", "farm");
            navigate("/farm-dashboard");
        } else if (username === 'rahul.s@deliverain.com' && password === 'welcome') {
            sessionStorage.setItem("role", "logistic");
            navigate("/order-book");
        }
    };

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <div className="top-bar"></div>
                    <div className="login-wrapper">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="logo">
                                        <img src={ScaffoldLogo} className="img-fluid" style={{ width: "150px" }}
                                            alt="Logo" />
                                    </div>

                                    <div className="form-group mb-3">
                                        <input type="text" className="form-control f-15 fw-500" id="user-name"
                                            placeholder="User Name" autoComplete="username" data-val="true"
                                            data-val-required="Username field is required" name="userName" value={username} onChange={(e) => setUsername(e.target.value)} />
                                        <span className="text-danger field-validation-valid" data-valmsg-for="userName"
                                            data-valmsg-replace="true"></span>
                                    </div>
                                    <div className="form-group position-relative mb-3">
                                        <span className="i-icon">
                                            {!showPassword &&
                                                <img id="eye-hide" src={EyeSlash} alt="Show" data-toggle="tooltip"
                                                    title="Show Password" onClick={() => setShowPassword(!showPassword)} />
                                            }
                                            {showPassword &&
                                                <img id="eye-show" src={Eye} alt="Hide" data-toggle="tooltip"
                                                    title="Hide Password" onClick={() => setShowPassword(!showPassword)} />}
                                        </span>
                                        <input type={showPassword ? "text" : "password"} className="form-control f-15 fw-500" id="password"
                                            placeholder="Password" autoComplete="current-password" data-val="true"
                                            data-val-required="Password field is required" name="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                        <span className="text-danger field-validation-valid" data-valmsg-for="password"
                                            data-valmsg-replace="true"></span>
                                    </div>
                                    <div className="form-group text-center mt-5">
                                        <a>
                                            <input id="Submit" type="submit"
                                                className="btn btn-block enquiry-form-vilot-button f-15 fw-500"
                                                style={{ justifyContent: "center" }} value="Login" onClick={() => auth()} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
export default Login;